import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import {
  CodeEditor,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@elementary/common-ui/components';
import useSelectedWarehouseType from 'shared/hooks/useSelectedWarehouseType';
import { radius, space } from '@elementary/common-ui/style/utils';

const TabContainer = styled(Stack)`
  padding: ${space('xxl')};
  border: 1px solid ${({ theme }) => theme.palette.border.faint};
  border-radius: ${radius('lg')};
  gap: ${space('lg')};
  overflow: auto;
  max-height: 600px;
`;

const QueryAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    height: auto;
    min-height: 48px;
    padding: ${space('md', 'lg')};
  }
`;

const QueryAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`;

type Props = {
  queries?: string[] | null;
};

const BiQueriesTabContent = ({ queries }: Props) => {
  const warehouseType = useSelectedWarehouseType();

  if (!queries || queries.length === 0) {
    return (
      <TabContainer>
        <Typography>No queries found</Typography>
      </TabContainer>
    );
  }

  return (
    <TabContainer>
      {queries.map((query, index) => (
        <Accordion key={index} defaultExpanded={index === 0}>
          <QueryAccordionSummary>
            <Typography variant="subtitle2">Query {index + 1}</Typography>
          </QueryAccordionSummary>
          <QueryAccordionDetails>
            <CodeEditor
              value={query}
              mode="sql"
              warehouseType={warehouseType}
              readOnly
              height="300px"
            />
          </QueryAccordionDetails>
        </Accordion>
      ))}
    </TabContainer>
  );
};

export default BiQueriesTabContent;
